import { PaymentMethodListItem } from '../apis/paymentMethodApi';

export enum PaymentMethodType {
  CARD = 'card',
  US_BANK_ACCOUNT = 'us_bank_account',
}

export enum CardFunding {
  Credit = 'credit',
  Debit = 'debit',
  Prepaid = 'prepaid',
}

export function formatExpBank(item: PaymentMethodListItem, expPrefix: string = '') {
  if (item.paymentType === 'card') {
    const expiration = item.expiration;
    if (expiration) {
      const segments = item.expiration.split('/');
      if (segments.length > 2) {
        return `${expPrefix}${segments[0]}/${segments[2].slice(-2)}`;
      }
      if (segments.length === 2) {
        return `${expPrefix}${segments[0]}/${segments[1].slice(-2)}`;
      }
      return `${expPrefix}${segments[0]}`;
    }
    return expiration;
  }
  return item.accountBrand;
}

export function isExpired(item: PaymentMethodListItem) {
  const currentDate = new Date();
  if (item.expiration) {
    const segments = item.expiration.split('/');
    const expYear = parseInt(segments[1]);
    const expMonth = parseInt(segments[0]);
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    if (expYear < currentYear) {
      return true;
    }
    if (expYear > currentYear) {
      return false;
    }
    return expMonth < currentMonth;
  }
}
